/* Croatian pluralization for the handwritten points note: 1 bod, 2–4 boda
   (and any decimal like 0,5), everything else bodova. */
export const renderPoints = (points: string | number | undefined): string => {
	const raw = String(points ?? '').trim();
	if (!raw) return '';
	const value = Number(raw.replace(',', '.'));
	if (Number.isNaN(value)) return raw;
	const label =
		!Number.isInteger(value) || (value >= 2 && value <= 4)
			? 'boda'
			: value === 1
				? 'bod'
				: 'bodova';
	return `${raw.replace('.', ',')} ${label}`;
};
